<div class="not-found">
  <svg-icon src="assets/svg/obi.svg"></svg-icon>
  <div class="text">
    <div class="heading">404 error</div>
    <div class="sub">This isn't the page you're looking for...</div>
  </div>
</div>
